import React, {useState} from 'react';

import {ButtonWithPopOut} from '@newsela/angelou';
import {css} from 'emotion';
import _uniqueId from 'lodash-es/uniqueId';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';

import TrackedLinkContainer from 'static/three-oh/src/components/TrackedLink/';
import withTrackEvent from 'static/three-oh/src/components/with/WithTrackEvent';
import {deleteSessionRequest} from 'static/three-oh/src/modules/actions/sessionActions';
import {getUserProperties} from 'static/three-oh/src/modules/selectors/userSelectors';
import {heapSignOut} from 'static/three-oh/utils/sessionActivity';

import {listItemLinkStyle} from '../../GlobalNav/DrawerContents/style';
import NavMenuList from '../../NavMenuList';
import NavMenuListItem from '../../NavMenuList/NavMenuListItem';
import LicenseList from '../LicenseList';
import UserAvatar from '../UserAvatar';
import {
  avatarArea,
  emailArea,
  userNameArea,
  userSectionStyle,
  navMenuListStyles,
  buttonWithPopOutStyle
} from './style.jsx';

const ButtonWithPopOutWithTrackEvent = withTrackEvent(ButtonWithPopOut);


const propTypes = {
  ariaProps: PropTypes.obj,
  buttonContents: PropTypes.node,
  email: PropTypes.string.isRequired,
  isStudent: PropTypes.bool,
  isVisible: PropTypes.bool,
  onClickOff: PropTypes.func.isRequired,
  onClickButton: PropTypes.func.isRequired,
  onEsc: PropTypes.func.isRequired,
  renderMessages: PropTypes.func,
  userName: PropTypes.string.isRequired,
};


export const UserAvatarPopOut = React.forwardRef((props, ref) => {
  UserAvatarPopOut.displayName = 'UserAvatarPopOut';
  const dispatch = useDispatch();
  // If a prop was passed in due to env (storybook or angular) lets use that prop otherwise grab it from redux
  const isStudent = props.isStudent ? props.isStudent : useSelector((state) => getUserProperties(state).isStudent);

  const {buttonContents} = props;
  const [avatarButtonId] = useState(_uniqueId('avatarCenter'));

  const content = (isStudent) => {
    return (
      <div className={navMenuListStyles}>
        <div
          className={userSectionStyle}
        >
          <div
            className={avatarArea}
          >
            <UserAvatar
              userName={props.userName}
              ariaProps={{
                'aria-hidden': true
              }}
            />
          </div>
          <div
            className={userNameArea}
          >
            {props.userName}
          </div>
          <div
            className={emailArea}
          >
            {props.email}
          </div>
        </div>

        {isStudent ? null :
        <LicenseList />}

        <NavMenuList additionalClassName={navMenuListStyles}>
          <NavMenuListItem>
            <TrackedLinkContainer
              href="/settings"
              eventName="clicked-utility-settings"
              eventProperties={{
                description: 'clicked settings link in avatar pop out',
              }}
              className={css(listItemLinkStyle)}
            >
              Settings
            </TrackedLinkContainer>
          </NavMenuListItem>
          <NavMenuListItem>
            <TrackedLinkContainer
              href="/"
              eventProperties={{
                description: 'clicked sign out link in avatar pop out',
              }}
              postTrackClickFunction={(e) => {
                e.preventDefault();
                heapSignOut();
                sessionStorage.removeItem('recentSearchTerms');
                dispatch(deleteSessionRequest());
              }}
              className={css(listItemLinkStyle)}
            >
              Sign out
            </TrackedLinkContainer>
          </NavMenuListItem>
        </NavMenuList>
      </div>
    );
  };

  return (
    <ButtonWithPopOutWithTrackEvent
      id={avatarButtonId}
      actionPrefix={props.isVisible ? 'Initiate' : 'Cancel'}
      actionName="Navigate"
      legacyEventName="click-utility-avatar"
      streamProperties={{description: 'Toggle settings dropdown.'}}
      buttonContents={buttonContents}
      popOutContents={content(isStudent)}
      ariaProps={props.ariaProps}
      isPopOutVisible={props.isVisible}
      onClickButton={props.onClickButton}
      onEsc={props.onEsc}
      onClickOff={props.onClickOff}
      __cssFor={buttonWithPopOutStyle}
      ref={ref}
    />
  );
});

UserAvatarPopOut.propTypes = propTypes;

export default UserAvatarPopOut;
